import { sql } from "kysely";
type SortSqlBuilder = typeof sql;

function candidateRateSortExp(rateField: "expected" | "current" | "min") {
  return (sqlBuilder: SortSqlBuilder, tableName: string) => sqlBuilder`(
    CASE
      WHEN ${sqlBuilder.ref(`${tableName}.rate`)} IS NULL THEN NULL
      ELSE (
        CASE
          WHEN substring(lower(coalesce(${sqlBuilder.ref(`${tableName}.rate`)} ->> ${rateField}, '')) from '([0-9]+([.,][0-9]+)?)') IS NULL
            THEN NULL
          WHEN lower(coalesce(${sqlBuilder.ref(`${tableName}.rate`)} ->> ${rateField}, '')) ~ '[0-9]+([.,][0-9]+)?[[:space:]]*k([^a-z]|$)'
            THEN replace(
              substring(lower(coalesce(${sqlBuilder.ref(`${tableName}.rate`)} ->> ${rateField}, '')) from '([0-9]+([.,][0-9]+)?)'),
              ',',
              ''
            )::numeric * 1000
          ELSE replace(
            substring(lower(coalesce(${sqlBuilder.ref(`${tableName}.rate`)} ->> ${rateField}, '')) from '([0-9]+([.,][0-9]+)?)'),
            ',',
            ''
          )::numeric
        END
      )
    END
  )`;
}

export const recruitmentCandidatesSorts = {
  full_name: {
    isVirtual: true,
    sortExp: (sqlBuilder: SortSqlBuilder, tableName: string) =>
      sqlBuilder`concat(${sqlBuilder.ref(`${tableName}.first_name`)}, ' ', ${sqlBuilder.ref(`${tableName}.last_name`)})`,
  },
  current_role: {
    isVirtual: true,
    sortExp: (sqlBuilder: SortSqlBuilder, tableName: string) =>
      sqlBuilder`${sqlBuilder.ref(`${tableName}.experience`)}->0->>'title'`,
  },
  current_employer: {
    isVirtual: true,
    sortExp: (sqlBuilder: SortSqlBuilder, tableName: string) =>
      sqlBuilder`${sqlBuilder.ref(`${tableName}.experience`)}->0->>'company'`,
  },
  "rate.expected": {
    isVirtual: true,
    sortExp: candidateRateSortExp("expected"),
  },
  "rate.current": {
    isVirtual: true,
    sortExp: candidateRateSortExp("current"),
  },
  "rate.min": {
    isVirtual: true,
    sortExp: candidateRateSortExp("min"),
  },
  skills: {
    isVirtual: true,
    sortExp: (sqlBuilder: SortSqlBuilder, tableName: string) =>
      sqlBuilder`${sqlBuilder.ref(`${tableName}.skills`)}::text`,
  },
  "candidateProfile:experience": {
    isVirtual: true,
    sortExp: (sqlBuilder: SortSqlBuilder, tableName: string) =>
      sqlBuilder`${sqlBuilder.ref(`${tableName}.experience`)}::text`,
  },
  "candidateProfile:education": {
    isVirtual: true,
    sortExp: (sqlBuilder: SortSqlBuilder, tableName: string) =>
      sqlBuilder`${sqlBuilder.ref(`${tableName}.education`)}::text`,
  },
};

export const recruitmentApplicationsSorts = {
  full_name: {
    isVirtual: true,
    sortExp: (sqlBuilder: SortSqlBuilder, tableName: string) =>
      sqlBuilder`concat(${sqlBuilder.ref(`${tableName}.first_name`)}, ' ', ${sqlBuilder.ref(`${tableName}.last_name`)})`,
  },
  title: {
    isVirtual: true,
    sortExp: (sqlBuilder: SortSqlBuilder) => sqlBuilder`${sqlBuilder.ref("recruitment_jobs.title")}`,
  },
  candidate_email: {
    isVirtual: true,
    sortExp: (sqlBuilder: SortSqlBuilder, tableName: string) => sqlBuilder`${sqlBuilder.ref(`${tableName}.email`)}`,
  },
};

export const recruitmentJobsSorts = {
  submissions_count: {
    isVirtual: true,
    sortExp: (sqlBuilder: SortSqlBuilder, tableName: string) => sqlBuilder`(
      SELECT count(*)::int
      FROM recruitment_job_submissions
      WHERE recruitment_job_submissions.job_id = ${sqlBuilder.ref(`${tableName}.id`)}
    )`,
  },
};

export const dataSortsMapping = {
  recruitment_jobs: recruitmentJobsSorts,
  recruitment_candidates: recruitmentCandidatesSorts,
  recruitment_applications: recruitmentApplicationsSorts,
};

export const NATIVE_SORT_ALLOWLIST: Record<string, Array<{ id: string; label: string }>> = {
  recruitment_candidates: [
    { id: "full_name", label: "Candidate" },
    { id: "first_name", label: "First name" },
    { id: "last_name", label: "Last name" },
    { id: "email", label: "Email" },
    { id: "phone", label: "Phone" },
    { id: "remote_id", label: "Remote ID" },
    { id: "location", label: "Location" },
    { id: "status", label: "Status" },
    { id: "current_role", label: "Role" },
    { id: "current_employer", label: "Company" },
    { id: "employment_preference", label: "Employment preference" },
    { id: "willing_to_relocate", label: "Willing to relocate" },
    { id: "rate.expected", label: "Expected salary" },
    { id: "rate.current", label: "Current salary" },
    { id: "rate.min", label: "Minimum salary" },
    { id: "skills", label: "Skills" },
    { id: "candidateProfile:experience", label: "Experience" },
    { id: "candidateProfile:education", label: "Education" },
    { id: "description", label: "Summary" },
    { id: "skill_set_matched", label: "Skill set" },
    { id: "updated_at", label: "Updated" },
    { id: "created_at", label: "Created" },
  ],
  recruitment_jobs: [
    { id: "title", label: "Role" },
    { id: "status", label: "Status" },
    { id: "location", label: "Location" },
    { id: "submissions_count", label: "Submissions" },
    { id: "created_at", label: "Created" },
    { id: "updated_at", label: "Updated" },
  ],
  recruitment_clients: [
    { id: "name", label: "Client" },
    { id: "industry", label: "Industry" },
    { id: "created_at", label: "Created" },
    { id: "updated_at", label: "Updated" },
  ],
  contacts: [
    { id: "full_name", label: "Contact" },
    { id: "status", label: "Relationship" },
    { id: "created_at", label: "Created" },
    { id: "updated_at", label: "Updated" },
  ],
  recruitment_applications: [
    { id: "stage", label: "Stage" },
    { id: "title", label: "Job" },
    { id: "full_name", label: "Candidate" },
    { id: "candidate_email", label: "Email" },
    { id: "created_at", label: "Created" },
    { id: "updated_at", label: "Updated" },
  ],
};
